import * as yup from 'yup';

export default function StringRequiredWhenValue(label, value) {
  return yup.string().oneOf([value], label);
}
